// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import {
//   Code2,
//   CurlyBraces,
//   ChevronDown,
//   Cpu,
//   Database,
//   FileText,
//   Bug,
//   Terminal,
//   Gamepad2,
//   Layers,
//   HelpCircle,
//   Briefcase,
//   FolderCheck,
//   Clock,
// } from "lucide-react";

// const IMAGES = {
//   hero: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2070&auto=format&fit=crop",
//   lab: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=2070&auto=format&fit=crop",
// };

// export default function CCPP() {
//   const [openFAQ, setOpenFAQ] = useState(null);

//   // Split into two columns
//   const leftColumn = faqs.filter((_, i) => i % 2 === 0);
//   const rightColumn = faqs.filter((_, i) => i % 2 !== 0);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const commonProjects = [
//     {
//       title: "Command Line Utilities",
//       desc: "Small tools to practice file I/O, parsing, and process control.",
//       icon: Terminal,
//       gradient: "from-pink-200 via-purple-200 to-indigo-200",
//     },
//     {
//       title: "Data Structures Library",
//       desc: "Implement linked lists, stacks, queues, and trees from scratch.",
//       icon: Layers,
//       gradient: "from-yellow-200 via-orange-200 to-red-200",
//     },
//     {
//       title: "Mini Game",
//       desc: "Text-based games to practice algorithms and design.",
//       icon: Gamepad2,
//       gradient: "from-green-200 via-emerald-200 to-teal-200",
//     },
//   ];

//   const cSyllabus = [
//     {
//       text: "C syntax & compilation flow (gcc)",
//       icon: Code2,
//       gradient: "from-sky-200 via-indigo-200 to-purple-200",
//     },
//     {
//       text: "Pointers, arrays, and memory model",
//       icon: Cpu,
//       gradient: "from-pink-200 via-red-200 to-orange-200",
//     },
//     {
//       text: "Structs, enums, and modular code",
//       icon: Database,
//       gradient: "from-yellow-200 via-lime-200 to-green-200",
//     },
//     {
//       text: "File handling and buffered I/O",
//       icon: FileText,
//       gradient: "from-purple-200 via-indigo-200 to-blue-200",
//     },
//     {
//       text: "Makefiles and debugging with gdb",
//       icon: Bug,
//       gradient: "from-teal-200 via-cyan-200 to-sky-200",
//     },
//   ];

//   const faqs = [
//     {
//       id: 1,
//       q: "Do I need prior experience?",
//       a: "No — we start from basics and guide you to advanced topics with hands-on exercises.",
//       icon: HelpCircle,
//       gradient: "from-rose-200 via-pink-200 to-fuchsia-200",
//     },
//     {
//       id: 2,
//       q: "Is placement help provided?",
//       a: "Yes — resume reviews, mock interviews, and industry connections are included.",
//       icon: Briefcase,
//       gradient: "from-cyan-200 via-blue-200 to-indigo-200",
//     },
//     {
//       id: 3,
//       q: "Will I build real-world projects?",
//       a: "Absolutely! You’ll create portfolio-ready projects.",
//       icon: FolderCheck,
//       gradient: "from-green-200 via-emerald-200 to-lime-200",
//     },
//     {
//       id: 4,
//       q: "How long is the course?",
//       a: "The program is structured for 10–12 weeks, depending on your pace.",
//       icon: Clock,
//       gradient: "from-yellow-200 via-orange-200 to-red-200",
//     },
//   ];
//   const renderFAQ = (faq) => (
//     <motion.div
//       key={faq.id}
//       className={`rounded-2xl border border-slate-200 shadow-md bg-gradient-to-r ${faq.gradient} cursor-pointer`}
//       initial={{ opacity: 0, rotateX: 45, y: 60 }}
//       whileInView={{ opacity: 1, rotateX: 0, y: 0 }}
//       whileHover={{
//         scale: 1.05,
//         rotate: [0, 2, -2, 2, 0],
//         transition: { repeat: Infinity, duration: 2 },
//       }}
//       transition={{ duration: 0.8 }}
//       viewport={{ once: true, amount: 0.2 }}
//       onClick={() => setOpenFAQ(openFAQ === faq.id ? null : faq.id)}
//     >
//       <div className="flex items-center justify-between p-6 font-semibold text-lg">
//         <div className="flex items-center gap-2">
//           <faq.icon className="h-5 w-5 text-indigo-700" />
//           {faq.q}
//         </div>
//         <ChevronDown
//           className={`h-5 w-5 transition-transform ${
//             openFAQ === faq.id ? "rotate-180" : ""
//           }`}
//         />
//       </div>
//       {openFAQ === faq.id && (
//         <motion.p
//           initial={{ opacity: 0, y: -10 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.4 }}
//           className="px-6 pb-6 text-slate-700"
//         >
//           {faq.a}
//         </motion.p>
//       )}
//     </motion.div>
//   );
//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-900">
//       {/* Hero */}
//       <section
//         className="relative py-24 text-white text-center bg-cover bg-center overflow-hidden"
//         style={{
//           backgroundImage:
//             "url('https://i.pinimg.com/1200x/a1/ac/1c/a1ac1cb42b57ac0e05c88ba826972ca4.jpg')",
//         }}
//       >
//         <div
//           className="absolute inset-0 bg-black bg-opacity-50"
//           style={{ pointerEvents: "none" }}
//         ></div>
//         <div className="relative max-w-4xl mx-auto px-4">
//           <h1
//             className="text-4xl md:text-6xl font-extrabold mb-4"
//             data-aos="fade-down"
//           >
//             C & C++ Masterclass
//           </h1>
//           <p
//             className="text-lg md:text-xl opacity-90 mb-6"
//             data-aos="fade-up"
//             data-aos-delay="150"
//           >
//             Learn low-level programming with C and modern system & application
//             development using C++ (C++11+).
//           </p>
//           <Link
//             to="/contact"
//             className="inline-block bg-white text-indigo-700 px-8 py-3 rounded-lg font-semibold shadow-lg hover:bg-gray-100 transition transform animate-bounce"
//             data-aos="zoom-in"
//             data-aos-delay="300"
//           >
//             🚀 Enroll Now
//           </Link>
//         </div>
//       </section>

//       {/* Syllabus + Projects */}
//       <section className="mx-auto max-w-6xl px-6 py-16">
//         <p className="text-center max-w-3xl mx-auto text-slate-600 mb-12">
//           Dive deep into the world of C programming to understand how computers
//           really work. From memory management to efficient coding techniques,
//           this syllabus builds a rock-solid foundation.
//         </p>
//         <div className="grid gap-12 md:grid-cols-2">
//           {/* Curriculum */}
//           <div style={{ perspective: "1200px" }}>
//             <h2 className="text-2xl font-bold">C Curriculum</h2>
//             <p className="mt-2 text-slate-600">
//               System-level programming fundamentals with C.
//             </p>
//             <ul className="mt-6 space-y-4">
//               {cSyllabus.map((it, i) => (
//                 <motion.li
//                   key={i}
//                   className={`flex items-start gap-3 rounded-xl bg-gradient-to-r ${it.gradient} p-5 shadow-md ring-1 ring-slate-300 animate-pulse`}
//                   initial={{ opacity: 0, rotateX: -45, scale: 0.9 }}
//                   whileInView={{ opacity: 1, rotateX: 0, scale: 1 }}
//                   whileHover={{
//                     y: [-6, 6, -6],
//                     rotate: [1, -1, 1],
//                     transition: { repeat: Infinity, duration: 1.5 },
//                   }}
//                   transition={{ duration: 0.8, delay: i * 0.15 }}
//                   viewport={{ once: true, amount: 0.3 }}
//                 >
//                   <it.icon className="mt-1 h-5 w-5 text-indigo-700" />
//                   <div className="font-medium">{it.text}</div>
//                 </motion.li>
//               ))}
//             </ul>
//           </div>

//           {/* Projects */}
//           <div style={{ perspective: "1200px" }}>
//             <h3 className="text-xl font-bold">Hands-on Projects</h3>
//             <p className="mt-2 text-slate-600">
//               Projects designed to reinforce concepts and build your portfolio.
//             </p>
//             <div className="mt-6 grid gap-6">
//               {commonProjects.map((p, i) => (
//                 <motion.div
//                   key={i}
//                   className={`rounded-xl bg-gradient-to-r ${p.gradient} p-5 shadow-md ring-1 ring-slate-300`}
//                   initial={{ opacity: 0, rotateY: 45, scale: 0.9 }}
//                   whileInView={{ opacity: 1, rotateY: 0, scale: 1 }}
//                   whileHover={{
//                     y: [0, -6, 6, -6, 0],
//                     rotate: [0, 2, -2, 2, 0],
//                     transition: { repeat: Infinity, duration: 2 },
//                   }}
//                   transition={{ duration: 0.8, delay: i * 0.2 }}
//                   viewport={{ once: true, amount: 0.3 }}
//                 >
//                   <div className="flex items-start gap-3">
//                     <p.icon className="h-6 w-6 text-indigo-700" />
//                     <div>
//                       <div className="font-semibold">{p.title}</div>
//                       <div className="text-sm text-slate-700">{p.desc}</div>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//             <div className="mt-6">
//               <motion.img
//                 src={IMAGES.lab}
//                 alt="lab"
//                 className="rounded-2xl object-cover shadow-lg w-full h-48"
//                 initial={{ opacity: 0, rotateY: -30, scale: 0.9 }}
//                 whileInView={{ opacity: 1, rotateY: 0, scale: 1 }}
//                 whileHover={{ scale: 1.05, rotate: 1 }}
//                 transition={{ duration: 1 }}
//                 viewport={{ once: true, amount: 0.3 }}
//               />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* FAQ */}
//       <section className="bg-white py-16">
//         <div className="mx-auto max-w-6xl px-6">
//           <h3 className="text-3xl font-bold mb-6 text-center">
//             Frequently Asked Questions
//           </h3>
//           <p className="text-center max-w-3xl mx-auto text-slate-600 mb-12">
//             We understand you may have questions before joining. Here are the
//             most common ones to help you make the right decision.
//           </p>

//           <div className="grid gap-8 md:grid-cols-2">
//             <div className="flex flex-col gap-6">
//               {leftColumn.map(renderFAQ)}
//             </div>
//             <div className="flex flex-col gap-6">
//               {rightColumn.map(renderFAQ)}
//             </div>
//           </div>
//         </div>
//       </section>
//       <section className="bg-gradient-to-r from-sky-600 to-indigo-600 py-16 text-white text-center">
//         <div className="max-w-3xl mx-auto px-6">
//           <h2 className="text-3xl md:text-4xl font-bold mb-4">
//             Start Your Career Now!
//           </h2>
//           <p className="mb-6 opacity-90">
//             Gain real skills, build real apps, and land your dream job.
//           </p>
//           <p className="mb-8 opacity-80">
//             By the end of this course, you’ll not only have a strong foundation
//             in C & C++ but also confidence to crack interviews and showcase your
//             projects proudly in your portfolio.
//           </p>
//           <a
//             href="/contact"
//             className="inline-block bg-white text-indigo-700 px-6 py-3 rounded-lg font-semibold shadow hover:bg-slate-100 transition animate-bounce"
//           >
//             Enroll Now
//           </a>
//         </div>
//       </section>
//     </div>
//   );
// }
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Code2,
  Cpu,
  Database,
  FileText,
  Bug,
  Terminal,
  Gamepad2,
  Layers,
  HelpCircle,
  Briefcase,
  FolderCheck,
  Clock,
  ChevronDown,
} from "lucide-react";

const IMAGES = {
  hero: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2070&auto=format&fit=crop",
  lab: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=2070&auto=format&fit=crop",
};

export default function CCPP() {
  const [openFAQ, setOpenFAQ] = useState(null);

  // FAQ array must be declared first
  const faqs = [
    {
      id: 1,
      q: "Do I need prior experience?",
      a: "No — we start from basics and guide you to advanced topics with hands-on exercises.",
      icon: HelpCircle,
      gradient: "from-rose-200 via-pink-200 to-fuchsia-200",
    },
    {
      id: 2,
      q: "Is placement help provided?",
      a: "Yes — resume reviews, mock interviews, and industry connections are included.",
      icon: Briefcase,
      gradient: "from-cyan-200 via-blue-200 to-indigo-200",
    },
    {
      id: 3,
      q: "Will I build real-world projects?",
      a: "Absolutely! You’ll create portfolio-ready projects.",
      icon: FolderCheck,
      gradient: "from-green-200 via-emerald-200 to-lime-200",
    },
    {
      id: 4,
      q: "How long is the course?",
      a: "The program is structured for 10–12 weeks, depending on your pace.",
      icon: Clock,
      gradient: "from-yellow-200 via-orange-200 to-red-200",
    },
  ];

  // Split into two columns
  const leftColumn = faqs.filter((_, i) => i % 2 === 0);
  const rightColumn = faqs.filter((_, i) => i % 2 !== 0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const commonProjects = [
    {
      title: "Command Line Utilities",
      desc: "Small tools to practice file I/O, parsing, and process control.",
      icon: Terminal,
      gradient: "from-pink-200 via-purple-200 to-indigo-200",
    },
    {
      title: "Data Structures Library",
      desc: "Implement linked lists, stacks, queues, and trees from scratch.",
      icon: Layers,
      gradient: "from-yellow-200 via-orange-200 to-red-200",
    },
    {
      title: "Mini Game",
      desc: "Text-based games to practice algorithms and design.",
      icon: Gamepad2,
      gradient: "from-green-200 via-emerald-200 to-teal-200",
    },
  ];

  const cSyllabus = [
    {
      text: "C syntax & compilation flow (gcc)",
      icon: Code2,
      gradient: "from-sky-200 via-indigo-200 to-purple-200",
    },
    {
      text: "Pointers, arrays, and memory model",
      icon: Cpu,
      gradient: "from-pink-200 via-red-200 to-orange-200",
    },
    {
      text: "Structs, enums, and modular code",
      icon: Database,
      gradient: "from-yellow-200 via-lime-200 to-green-200",
    },
    {
      text: "File handling and buffered I/O",
      icon: FileText,
      gradient: "from-purple-200 via-indigo-200 to-blue-200",
    },
    {
      text: "Makefiles and debugging with gdb",
      icon: Bug,
      gradient: "from-teal-200 via-cyan-200 to-sky-200",
    },
  ];

  const renderFAQ = (faq) => (
    <motion.div
      key={faq.id}
      className={`rounded-2xl border border-slate-200 shadow-md bg-gradient-to-r ${faq.gradient} cursor-pointer`}
      initial={{ opacity: 0, rotateX: 45, y: 60 }}
      whileInView={{ opacity: 1, rotateX: 0, y: 0 }}
      whileHover={{
        scale: 1.05,
        rotate: [0, 2, -2, 2, 0],
        transition: { repeat: Infinity, duration: 2 },
      }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, amount: 0.2 }}
      onClick={() => setOpenFAQ(openFAQ === faq.id ? null : faq.id)}
    >
      <div className="flex items-center justify-between p-6 font-semibold text-lg">
        <div className="flex items-center gap-2">
          <faq.icon className="h-5 w-5 text-indigo-700" />
          {faq.q}
        </div>
        <ChevronDown
          className={`h-5 w-5 transition-transform ${
            openFAQ === faq.id ? "rotate-180" : ""
          }`}
        />
      </div>
      {openFAQ === faq.id && (
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="px-6 pb-6 text-slate-700"
        >
          {faq.a}
        </motion.p>
      )}
    </motion.div>
  );

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      {/* Hero */}
      <section
        className="relative py-24 text-white text-center bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage:
            "url('../assets/a1ac1cb42b57ac0e05c88ba826972ca4.jpg')",
        }}
      >
        <div
          className="absolute inset-0 bg-black bg-opacity-50"
          style={{ pointerEvents: "none" }}
        ></div>
        <div className="relative max-w-4xl mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4">
            C & C++ Masterclass
          </h1>
          <p className="text-lg md:text-xl opacity-90 mb-6">
            Learn low-level programming with C and modern system & application
            development using C++ (C++11+).
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-indigo-700 px-8 py-3 rounded-lg font-semibold shadow-lg hover:bg-gray-100 transition transform animate-bounce"
          >
            🚀 Enroll Now
          </Link>
        </div>
      </section>

      {/* Syllabus + Projects */}
      <section className="mx-auto max-w-6xl px-6 py-16">
        <p className="text-center max-w-3xl mx-auto text-slate-600 mb-12">
          Dive deep into the world of C programming to understand how computers
          really work. From memory management to efficient coding techniques,
          this syllabus builds a rock-solid foundation.
        </p>
        <div className="grid gap-12 md:grid-cols-2">
          {/* Curriculum */}
          <div style={{ perspective: "1200px" }}>
            <h2 className="text-2xl font-bold">C Curriculum</h2>
            <p className="mt-2 text-slate-600">
              System-level programming fundamentals with C.
            </p>
            <ul className="mt-6 space-y-4">
              {cSyllabus.map((it, i) => (
                <motion.li
                  key={i}
                  className={`flex items-start gap-3 rounded-xl bg-gradient-to-r ${it.gradient} p-5 shadow-md ring-1 ring-slate-300 animate-pulse`}
                  initial={{ opacity: 0, rotateX: -45, scale: 0.9 }}
                  whileInView={{ opacity: 1, rotateX: 0, scale: 1 }}
                  whileHover={{
                    y: [-6, 6, -6],
                    rotate: [1, -1, 1],
                    transition: { repeat: Infinity, duration: 1.5 },
                  }}
                  transition={{ duration: 0.8, delay: i * 0.15 }}
                  viewport={{ once: true, amount: 0.3 }}
                >
                  <it.icon className="mt-1 h-5 w-5 text-indigo-700" />
                  <div className="font-medium">{it.text}</div>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Projects */}
          <div style={{ perspective: "1200px" }}>
            <h3 className="text-xl font-bold">Hands-on Projects</h3>
            <p className="mt-2 text-slate-600">
              Projects designed to reinforce concepts and build your portfolio.
            </p>
            <div className="mt-6 grid gap-6">
              {commonProjects.map((p, i) => (
                <motion.div
                  key={i}
                  className={`rounded-xl bg-gradient-to-r ${p.gradient} p-5 shadow-md ring-1 ring-slate-300`}
                  initial={{ opacity: 0, rotateY: 45, scale: 0.9 }}
                  whileInView={{ opacity: 1, rotateY: 0, scale: 1 }}
                  whileHover={{
                    y: [0, -6, 6, -6, 0],
                    rotate: [0, 2, -2, 2, 0],
                    transition: { repeat: Infinity, duration: 2 },
                  }}
                  transition={{ duration: 0.8, delay: i * 0.2 }}
                  viewport={{ once: true, amount: 0.3 }}
                >
                  <div className="flex items-start gap-3">
                    <p.icon className="h-6 w-6 text-indigo-700" />
                    <div>
                      <div className="font-semibold">{p.title}</div>
                      <div className="text-sm text-slate-700">{p.desc}</div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
            <div className="mt-6">
              <motion.img
                src={IMAGES.lab}
                alt="lab"
                className="rounded-2xl object-cover shadow-lg w-full h-48"
                initial={{ opacity: 0, rotateY: -30, scale: 0.9 }}
                whileInView={{ opacity: 1, rotateY: 0, scale: 1 }}
                whileHover={{ scale: 1.05, rotate: 1 }}
                transition={{ duration: 1 }}
                viewport={{ once: true, amount: 0.3 }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-16">
        <div className="mx-auto max-w-6xl px-6">
          <h3 className="text-3xl font-bold mb-6 text-center">
            Frequently Asked Questions
          </h3>
          <p className="text-center max-w-3xl mx-auto text-slate-600 mb-12">
            We understand you may have questions before joining. Here are the
            most common ones to help you make the right decision.
          </p>

          <div className="grid gap-8 md:grid-cols-2">
            <div className="flex flex-col gap-6">
              {leftColumn.map(renderFAQ)}
            </div>
            <div className="flex flex-col gap-6">
              {rightColumn.map(renderFAQ)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-gradient-to-r from-sky-600 to-indigo-600 py-16 text-white text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Start Your Career Now!
          </h2>
          <p className="mb-6 opacity-90">
            Gain real skills, build real apps, and land your dream job.
          </p>
          <p className="mb-8 opacity-80">
            By the end of this course, you’ll not only have a strong foundation
            in C & C++ but also confidence to crack interviews and showcase your
            projects proudly in your portfolio.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-indigo-700 px-6 py-3 rounded-lg font-semibold shadow hover:bg-slate-100 transition animate-bounce"
          >
            Enroll Now
          </Link>
        </div>
      </section>
    </div>
  );
}
